import { gql } from "@apollo/client/core";

export const auditsFragment = gql`
  fragment Audit on Log {
    type
    ownerId
    owner {
      id
      name
    }
    clientId
    client {
      id
      name
    }
    insertedAt
  }
`;

export const ME_CLIENT_PERSONAL_DATA_QUERY = gql`
  query PersonalData {
    meClient {
      id
      type

      # Personal Data
      firstName
      lastName
      birthDate
      birthPlace
      birthState
      birthCountry
      fiscalCode
      address
      city
      state
      zipCode
      country

      # Company Data
      officialName
      companyFiscalCode
      companyTvaNumber
      companyZipCode
      companyAddress
      companyCity
      companyCountry
      pecEmail
    }
  }
`;

export const CLIENT_UPDATE_DATA_MUTATION = gql`
  mutation ($params: PersonalDataInput!) {
    updateClientData(params: $params) {
      id
      type

      # Personal Data
      firstName
      lastName
      birthDate
      birthPlace
      birthState
      birthCountry
      fiscalCode
      address
      city
      state
      zipCode
      country

      # Company Data
      officialName
      companyFiscalCode
      companyTvaNumber
      companyZipCode
      companyAddress
      companyCity
      companyCountry
      pecEmail
    }
  }
`;

export const UPDATE_CLIENT_PASSWORD_MUTATION = gql`
  mutation (
    $password: String!
    $newPassword: String!
    $newPasswordConfirmation: String!
  ) {
    updateClientPassword(
      password: $password
      newPassword: $newPassword
      newPasswordConfirmation: $newPasswordConfirmation
    ) {
      email
    }
  }
`;
